export default {
    GET_FAILED: (name: string) => `Spending control ${name} editing failed. Please, try again.`,
    GET_SUCCESS_PRE: (name: string) => `Spending control ${name} ID `,
    SUCCESS_POST: ' was successfully updated.',
    TITLE: 'Edit spending control',
};
